<div class="m-1" [class.invalid]="isInvalid()">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label for="{{ effectiveControlId() }}" class="form-label">
            {{ label() }}
            @if (isRequired() || showAsRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
        </label>
    }
    @if (!isTextArea() && inputType() === "tel") {
        <input
            #textInput
            [id]="effectiveControlId()"
            [type]="controlType()"
            [maxlength]="maxLength()"
            [class]="classes()"
            [class.is-invalid]="isInvalid()"
            [class.text-center]="textAlignment() === 'center'"
            [class.text-left]="textAlignment() === 'left'"
            [class.text-right]="textAlignment() === 'right'"
            [placeholder]="placeholder()"
            [formControl]="inputControl"
            phone-number
            (ngModelChange)="valueChanged($event)"
        />
    } @else if (!isTextArea()) {
        <input
            #textInput
            [id]="effectiveControlId()"
            [type]="controlType()"
            [maxlength]="maxLength()"
            [class]="classes()"
            [class.is-invalid]="isInvalid()"
            [class.text-center]="textAlignment() === 'center'"
            [class.text-left]="textAlignment() === 'left'"
            [class.text-right]="textAlignment() === 'right'"
            [placeholder]="placeholder()"
            [formControl]="inputControl"
            [dir]="direction()"
            [blockedChars]="isPositiveInteger() ? positiveIntegerBlockedChars : []"
            (ngModelChange)="valueChanged($event)"
        />
    } @else {
        <textarea
            #textarea
            [id]="effectiveControlId()"
            cols="20"
            [attr.rows]="rows()"
            [class]="classes()"
            [class.is-invalid]="isInvalid()"
            [class.text-center]="textAlignment() === 'center'"
            [class.text-left]="textAlignment() === 'left'"
            [class.text-right]="textAlignment() === 'right'"
            style="resize: none"
            [maxlength]="maxLength()"
            [placeholder]="placeholder()"
            [formControl]="inputControl"
            (ngModelChange)="valueChanged($event)"
        ></textarea>
    }
</div>
